import React, { useState } from 'react';

const ProductDescription = ({ description }) => {
  const [showFullDescription, setShowFullDescription] = useState(false);

  const toggleDescription = () => {
    setShowFullDescription(!showFullDescription);
  };

  return (
    <div>
      <p>Description: {showFullDescription ? description : `${description.substring(0, 100)}...`}</p>
      {!showFullDescription && (
        <button onClick={toggleDescription}>Read more</button>
      )}
       {showFullDescription && <button onClick={toggleDescription}>Read less</button>}
    </div>
  );
};

export default ProductDescription;
